import type { DefaultHubPreferences } from "@/hooks/firestore/user/usePreferences";
import type { NavItem } from "../types";

export const preferredFirst = (
  items: NavItem[],
  defaultHub: DefaultHubPreferences | null,
): NavItem[] => {
  const preferred = defaultHub?.toLowerCase();
  const isPreferred = ({ id }: NavItem) =>
    id === preferred || id.startsWith(`${preferred}/`);

  return [
    ...items.filter(isPreferred),
    ...items.filter((item) => !isPreferred(item)),
  ];
};
